import apiSportsObjects from '@/api/sports-objects'

const state = {
  validationErrors: null,
  isSubmitting: false
}

export const mutationTypes = {
  deleteSportObjectsStart: '[delete sportsObjects] deleteSportObjectsStart',
  deleteSportObjectsSuccess: '[delete sportsObjects] deleteSportObjectsSuccess',
  deleteSportObjectsFailure: '[delete sportsObjects] deleteSportObjectsFailure'
}

export const actionType = {
  deleteSportObjects: '[delete sportsObjects] deleteSportObjects'
}

const mutations = {
  [mutationTypes.deleteSportObjectsStart](state) {
    state.isSubmitting = true
    state.validationErrors = null
  },

  [mutationTypes.deleteSportObjectsSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.deleteSportObjectsFailure](state, payload) {
    state.isSubmitting = false
    state.validationErrors = payload
  }
}

const actions = {
  [actionType.deleteSportObjects](context, {id}) {
    context.commit(mutationTypes.deleteSportObjectsStart)
    return new Promise(resolve => {
      apiSportsObjects
        .deleteSportObject(id)
        .then(response => {
          context.commit(mutationTypes.deleteSportObjectsSuccess, response.data)
          resolve(response.data)
        })
        .catch(result => {
          context.commit(
            mutationTypes.deleteSportObjectsFailure,
            result.response.data.errors
          )
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
